/**
 * Redirections des quatre anciens journaux fusionnés dans `/historique`
 * (L-NAV-5) : `/calls`, `/recordings`, `/sms/logs`, `/emails/logs` deviennent
 * les onglets Appels · Enregistrements · SMS · E-mails.
 *
 * Contrairement aux redirections LOT-H12, la REQUÊTE est conservée : les
 * journaux portent leur état dans l'URL (#259 — `?q=`, `?period=`,
 * `?status=`…), et un signet `/calls?status=NO_ANSWER` doit rouvrir le
 * journal filtré. L'état de navigation (`from`, `restoreScroll`) et le
 * fragment suivent aussi.
 *
 * Les gardes ne sont pas dupliquées ici : la page hôte les porte par onglet
 * (`pages/history/historyTabs.ts`) — un agent qui suit un vieux signet
 * `/sms/logs` aboutit, comme avant, sur le refus d'accès.
 *
 * `replace` : la redirection ne laisse pas d'entrée d'historique, sinon le
 * bouton « précédent » boucle (même décision que `legacyMergeRedirects`).
 *
 * Helper exporté — et non écrit en clair dans `App.tsx` — pour que
 * `legacyHistoryRedirects.spec.tsx` monte les VRAIES routes de production
 * (et que `AppShell.routeTitles.spec.ts`, qui lit les `<Route path>` du
 * source, ne les prenne pas pour des pages sans titre).
 */
import { Navigate, Route, useLocation } from 'react-router-dom'

import { historyHref, type HistoryTab } from '../pages/history/historyTabs'

/** Ancien chemin → onglet de `/historique`. */
export const LEGACY_HISTORY_REDIRECTS: ReadonlyArray<{ from: string; tab: HistoryTab }> = [
  { from: '/calls', tab: 'calls' },
  { from: '/recordings', tab: 'recordings' },
  { from: '/sms/logs', tab: 'sms' },
  { from: '/emails/logs', tab: 'emails' },
]

function LegacyHistoryRedirect({ tab }: { tab: HistoryTab }) {
  const location = useLocation()
  return <Navigate to={historyHref(tab, location.search) + location.hash} replace state={location.state} />
}

/** Routes à insérer dans l'arbre AUTHENTIFIÉ, avant le `*` de la 404. */
export function legacyHistoryRedirects() {
  return LEGACY_HISTORY_REDIRECTS.map(({ from, tab }) => (
    <Route key={from} path={from} element={<LegacyHistoryRedirect tab={tab} />} />
  ))
}
